/**
 * TODO: とりあえず挙動確認用に実装。後でデザインを決めて差し替える。
 * データがない場合のプレースホルダー画像を生成する
 */
export const generatePlaceholderImage = (name: string) => {
  const placeholderDataUrl = `data:image/svg+xml,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="192" height="108">
              <rect width="192" height="108" fill="#374151"/>
              <text x="96" y="54" text-anchor="middle" dominant-baseline="middle" fill="#9CA3AF" font-size="12">${name}</text>
            </svg>`
  )}`;

  return placeholderDataUrl;
};
